<template>
  <div class="m-x-3-lg m-x-2-md m-y-2-md">
    <span class="titulo-seccion">Prácticas específicas del MEIA</span>
    <h1 class="titulo">Mapa uso de maquinaria 2007</h1>

    <MapaUsoMaquinaria class="m-t-1" />
  </div>
</template>

<script>
import MapaUsoMaquinaria from "@/components/mapas/MapaUsoMaquinaria.vue"

export default {
  components: {
    MapaUsoMaquinaria,
  },
  mounted() {
    this.$store.commit('setTemaAlternativa', 'Prácticas específicas del MEIA');
    this.$store.commit('setSubtemaAlternativa', 'Mapa uso de maquinaria 2007');
  }
};
</script>
